import { NotificationSingle, NotificationType } from "@/types/notification";
import { Dispatch } from "vuex";

function setNotification(dispatch: Dispatch, message: string, type: NotificationType) {
  const notification: NotificationSingle = {
    type,
    message,
  };
  dispatch("notifications/add", notification, { root: true });
}

export function setNotificationSuccess(dispatch: Dispatch, message: string) {
  setNotification(dispatch, message, NotificationType.SUCCESS);
}

export function setNotificationError(dispatch: Dispatch, message: string) {
  setNotification(dispatch, message, NotificationType.ERROR);
}
